<template>
  <header v-if="!isPcRedesign" class="mobile-header">
    <button type="button" class="mobile-header-btn" @click="$emit('toggle-drawer')">
      <i class="fa-solid fa-bars"></i>
    </button>
    <div class="mobile-header-title">{{ pageTitle }}</div>
    <div class="mobile-header-actions"></div>
  </header>
</template>

<script>
import { mapState as mapPiniaState } from 'pinia'
import { useResponsive } from '@/composables/useResponsive.js'
import { useTabStore } from '@/stores/tabs'

/**
 * @component MobileHeader
 * @description PC 리디자인(1280px+) 이 아닌 모든 뷰포트(모바일/태블릿/작은 PC)에서 표시되는 상단 헤더.
 * 좌측 햄버거 버튼, 중앙 현재 화면명으로 구성되며, 햄버거 버튼 클릭 시 toggle-drawer를 emit합니다.
 */
export default {
  name: 'MobileHeader',
  emits: ['toggle-drawer'],
  setup() {
    const { isPcRedesign } = useResponsive()
    return { isPcRedesign }
  },
  computed: {
    ...mapPiniaState(useTabStore, ['activeTabTitle']),
    /**
     * 중앙에 표시할 화면명. 활성 탭 title 이 없으면 현재 라우트 name 을 사용합니다.
     */
    pageTitle() {
      return this.activeTabTitle || this.$route?.name || ''
    }
  }
}
</script>

<style scoped>
.mobile-header {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  background: var(--color-primary-dark);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  z-index: 998;
  transition: background 0.3s ease;
}
.mobile-header-title {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  font-size: 15px;
  font-weight: 600;
  max-width: 60%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: center;
}
.mobile-header-btn {
  width: 44px;
  height: 44px;
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.mobile-header-actions {
  display: flex;
  gap: 4px;
}

</style>
